import React, { useEffect, useState } from "react";
import { DatePicker, Image, message, Table, Typography } from "antd";
import dayjs from "dayjs";
import { api } from "../../api/api";
import { API } from "../../config/config";
import { IUserArchive } from "../../types/archiveUser.type";

const { Title } = Typography;
const { RangePicker } = DatePicker;

export default function ArchiveUsers() {
  const [users, setUsers] = useState<IUserArchive[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [dateRange, setDateRange] = useState<
    [dayjs.Dayjs, dayjs.Dayjs] | undefined
  >([dayjs().startOf("month"), dayjs().endOf("month")]);

  const handleRangeChange = (dates: any) => {
    if (dates) {
      setDateRange([dates[0], dates[1]]);
    } else {
      setDateRange(undefined);
    }
  };

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await api.get("/archive/users", {
        params: {
          page,
          limit: pageSize,
          startDate: dateRange ? dateRange[0]?.format("DD.MM.YY") : undefined,
          endDate: dateRange ? dateRange[1]?.format("DD.MM.YY") : undefined,
        },
      });

      const { users, total } = response.data;

      setUsers(users);
      setTotal(total);
    } catch (error) {
      console.log(error);
      message.error("Ошибка получение пользователей.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [page, pageSize, dateRange]);

  const columns = [
    {
      title: "Дата удаления",
      dataIndex: "dateRemoved",
      key: "dateRemoved",
    },
    {
      title: "Удалил",
      dataIndex: "removedBy",
      key: "removedBy",
    },
    {
      title: "Имя",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Логин",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "Роль",
      dataIndex: "role",
      key: "role",
    },
  ];
  return (
    <div style={{ padding: 24 }}>
      <Title level={2}>Архив Пользователей</Title>
      <RangePicker
        onChange={handleRangeChange}
        placeholder={["Начало", "Конец"]}
        format="DD.MM.YY"
        value={dateRange}
      />

      <Table
        columns={columns}
        dataSource={users}
        rowKey={(record) => record._id}
        pagination={{
          current: page,
          total: total,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPage(page);
            if (size !== pageSize) setPageSize(size!);
          },
          showSizeChanger: true,
        }}
        scroll={{ x: "max-content" }}
        loading={loading}
      />
    </div>
  );
}
